<template>
  <div class="routerview md:mt-18 flex min-h-screen items-center bg-gray-50">
    <div class="mx-auto max-w-3xl px-4 py-12">
      <div class="rounded-2xl border border-gray-100 bg-white px-8 py-10 shadow-lg">
        <div class="text-center">
          <div class="mx-auto flex h-20 w-20 items-center justify-center">
            <img
              v-if="tier === 1"
              v-local-img="'pmg-logo-no-white.png'"
              alt="PlayMoreGolf Logo"
              class="h-20 w-20 object-contain"
            >
            <img
              v-else-if="tier === 2"
              v-local-img="'pmg-logo-no-white.png'"
              alt="XVIII.GOLF Logo"
              class="h-20 w-20 object-contain"
            >
            <img
              v-else
              v-local-img="'IXLogoNoBackground.png'"
              alt="IX.GOLF Logo"
              class="h-20 w-20 object-contain"
            >
          </div>

          <h1 class="mt-6 text-3xl font-bold text-gray-900">
            {{ titleText }}
          </h1>

          <p class="mt-4 text-lg text-gray-600">
            {{ descriptionText }}
          </p>

          <div
            v-if="!$isMobile.value"
            class="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center"
          >
            <PrimaryButton
              :text="buttonText"
              @click="redirect"
            />
          </div>

          <div
            v-if="$isMobile.value && appStoreLinks && appStoreLinks.googlePlay"
            class="mt-8 flex items-center justify-between px-6"
          >
            <a :href="appStoreLinks.googlePlay">
              <img
                v-local-img="'googleplaylogo.png'"
                class="h-16 p-2"
                alt="Get it on Google Play"
              >
            </a>
            <a :href="appStoreLinks.appStore">
              <img
                v-local-img="'Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'"
                class="h-16 p-2"
                alt="Get it on iOS"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';

export default {
  name: 'TierRedirectView',
  components: {
    PrimaryButton,
  },
  props: {
    tier: {
      type: Number,
      required: true,
    },
    appStoreLinks: {
      type: Object,
      default: null,
    },
  },
  computed: {
    titleText() {
      if (this.tier === 1) {
        return 'Your club now operates on the playmore.golf platform.';
      }
      if (this.tier === 2) {
        return 'Your club now operates on the XVIII.GOLF platform.';
      }
      return 'Your club now operates on the IX.GOLF platform.';
    },
    descriptionText() {
      return 'Use this platform to manage your membership and bookings.';
    },
    buttonText() {
      if (this.tier === 1) {
        return 'Go to PlayMoreGolf';
      }
      if (this.tier === 2) {
        return 'Go to XVIII.GOLF';
      }
      return 'Go to IX.GOLF';
    },
    redirectUrl() {
      if (this.tier === 1) {
        return 'https://account.playmore.golf/';
      }
      if (this.tier === 2) {
        return 'https://account.xviii.golf/';
      }
      return 'https://account.ix.golf/';
    },
  },
  methods: {
    redirect() {
      window.location.href = this.redirectUrl;
    },
  },
};
</script>

<style scoped></style>
